import React, { useState, useEffect } from "react";
import Form from "../../../../Components/Form";
import TextInput from "../../../../Components/Form/TextInput";
import Workspace from "../../../../APIController/Workspace";
import Text from "../../../../Components/Text";

const AddWorkspaceUserForm = ({afterAction})=>{
    const [email, setEmail] = useState("")

    /* API Controller */
    const {addUserPerCode} = Workspace()

    const handleAddUser = async()=>{
        const userEmailDTO = {
            email: email
        }
        await addUserPerCode(userEmailDTO)
        afterAction()
    }

    const handleSubmit = (e)=>{
        e.preventDefault()
        handleAddUser()
    }
    return (
        <Form onSubmitAction={handleSubmit} submitButtonText={"Mitarbeiter hinzufügen"}>
            <Text type="maintitle" classNames={"flex text-center justify-center"}>{"Mitarbeiter hinzufügen"}</Text>
            <TextInput attribute={email} id={"email"} label={"E-Mail"} placeholder={"E-Mail des Mitarbeiters"} action={(e) => setEmail(e.target.value)} />
        </Form>
    );
}
export default AddWorkspaceUserForm